<template>
  <div class="col-xs-12">
    <base-card>
      <div class="card-display mb_25 aspect_ratio_16_9"></div>
      <div class="card-title mb_20">{{ module.name }}</div>
      <div class="card-description mb_20">{{ module.description }}</div>
      <div class="card-price mb_25">
        {{ Utils.convertMoney(module.price) }}
        <span class="card-period">{{ module.period }}</span>
      </div>
    </base-card>
  </div>
</template>
<script>
import Utils from "@/utils";
import BaseTitle from "@/components/Title";
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";

export default {
  components: { BaseTitle, BaseButton, BaseCard },
  props: {
    module: { type: Object, default: {} },
  },
  data() {
    return {
      Utils,
    };
  },
};
</script>
<style scoped>
.card-title {
  text-align: left;
  font: normal normal 900 16px/19px Lato;
  letter-spacing: 0px;
  color: #777777;
  opacity: 1;
}

.card-description {
  text-align: left;
  font: normal normal 300 14px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}

.card-price {
  text-align: left;
  font: normal normal bold 18px/22px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.card-period {
  text-align: left;
  font: normal normal 300 18px/22px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
  text-transform: lowercase;
}

.card-actions {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.card-actions button {
  flex: 1;
}

.aspect_ratio_16_9 {
  position: relative;
  background-color: #0088dd1a;
}

.aspect_ratio_16_9 .content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.aspect_ratio_16_9::after {
  position: relative;
  display: block;
  content: " ";
  padding-bottom: 56.25%; /* 16:9 -> 9/16 -> 56.25% de altura */
}
</style>